import { rootStateBranchSelector } from '../rootStateBranchSelector';

export const getUser = rootStateBranchSelector('user');
